export const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', });

export const apiCall = async (method, url, payload) => {
    const response = await fetch(url, {
        method: method, 
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    if (!response.ok) {
        const r     = await response.text(),
              rj    = JSON.parse(r);
        throw new Error(rj.message);
    }
    const r = await response.text();
    return r ? JSON.parse(r) : {};
}

export function debounce(func, timeout = inputDelay){
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export function imgURL(src, size) {
    // remove any current image size then add the new image size
    return src
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
            return '_'+size+match;
        })
    ;
}

export function truncateString(str, num) {
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + '...';
}